import { render, staticRenderFns } from "./AuthActionButton.vue?vue&type=template&id=56c669f7&scoped=true"
import script from "./AuthActionButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./AuthActionButton.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AuthActionButton.vue?vue&type=style&index=0&id=56c669f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c669f7",
  null
  
)

export default component.exports